import { connect } from 'react-redux'
import { setAppCaptcha } from './actions'
import component from './component'


export default connect(
    null,
    { setAppCaptcha }
)(component)
